<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">资产编号</label>
            <em class="weui-form-preview__value">{{ form.main.fa_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fa_date">
            <label class="weui-form-preview__label">{{customLabel.fa_date || "日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.fa_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_relationcode">
            <label class="weui-form-preview__label">{{customLabel.fa_relationcode || "采购单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_relationcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_name">
            <label class="weui-form-preview__label">{{customLabel.fa_name || "资产名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_class">
            <label class="weui-form-preview__label">{{customLabel.fa_class || "资产类别"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_class
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_model">
            <label class="weui-form-preview__label">{{customLabel.fa_model || "规格型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_model
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_brand">
            <label class="weui-form-preview__label">{{customLabel.fa_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_brand
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_unit"> 
            <label class="weui-form-preview__label">{{customLabel.fa_unit || "单位"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_unit
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_buydate">
            <label class="weui-form-preview__label">{{customLabel.fa_buydate || "入库日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.fa_buydate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_user">
            <label class="weui-form-preview__label">{{customLabel.fa_user || "领用人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_user
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_deptname">
            <label class="weui-form-preview__label">{{customLabel.fa_deptname || "领用部门"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_deptname
            }}</span>
          </div>
        </custom-layout>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fa_currency">
            <label class="weui-form-preview__label">{{customLabel.fa_currency || "币种"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_currency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_unitprice">
            <label class="weui-form-preview__label">{{customLabel.fa_unitprice || "单价"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_unitprice
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_number">
            <label class="weui-form-preview__label">{{customLabel.fa_number || "数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_number
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_orivalue">
            <label class="weui-form-preview__label">{{customLabel.fa_orivalue || "原值"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_orivalue
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_oriunitprice">
            <label class="weui-form-preview__label">{{customLabel.fa_oriunitprice || "原币单价"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_oriunitprice
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_oriamount">
            <label class="weui-form-preview__label">{{customLabel.fa_oriamount || "原币金额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_oriamount
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_taxrate">
            <label class="weui-form-preview__label">{{customLabel.fa_taxrate || "税率"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_taxrate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_buyamount">
            <label class="weui-form-preview__label">{{customLabel.fa_buyamount || "含税金额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_buyamount
            }}</span>
          </div>
        </custom-layout>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fa_supname">
            <label class="weui-form-preview__label">{{customLabel.fa_supname || "供应商名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_supname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_supaddr">
            <label class="weui-form-preview__label">{{customLabel.fa_supaddr || "联系地址"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_supaddr
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_supphone">
            <label class="weui-form-preview__label">{{customLabel.fa_supphone || "联系电话"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_supphone
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_depositaddr">
            <label class="weui-form-preview__label">{{customLabel.fa_depositaddr || "存放地点"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_depositaddr
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_usestatus">
            <label class="weui-form-preview__label">{{customLabel.fa_usestatus || "使用状态"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_usestatus
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_addway">
            <label class="weui-form-preview__label">{{customLabel.fa_addway || "增加方式"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_addway
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_facaname">
            <label class="weui-form-preview__label">{{customLabel.fa_facaname || "固定资产科目"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_facaname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_resvalrate">
            <label class="weui-form-preview__label">{{customLabel.fa_resvalrate || "净残值率(%)"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_resvalrate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_residualval">
            <label class="weui-form-preview__label">{{customLabel.fa_residualval || "净残值"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_residualval
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_remark">
            <label class="weui-form-preview__label">{{customLabel.fa_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_remark
            }}</span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fa_deprcaname">
            <label class="weui-form-preview__label">{{customLabel.fa_deprcaname || "累计折旧科目"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.fa_deprcacode }} {{ form.main.fa_deprcaname }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="fa_deprexpname">
            <label class="weui-form-preview__label">{{customLabel.fa_deprexpname || "折旧费用科目"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.fa_deprexpcode }}
              {{ form.main.fa_deprexpname }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="fa_deprway">
            <label class="weui-form-preview__label">{{customLabel.fa_deprway || "折旧方法"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_deprway
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_deprmonth">
            <label class="weui-form-preview__label">{{customLabel.fa_deprmonth || "折旧月份"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_deprmonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_depryears">
            <label class="weui-form-preview__label">{{customLabel.fa_depryears || "折旧年限"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_depryears
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_deprrate">
            <label class="weui-form-preview__label">{{customLabel.fa_deprrate || "年折旧率(%)"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_deprrate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_monthdeprrate">
            <label class="weui-form-preview__label">{{customLabel.fa_monthdeprrate || "月折旧率(%)"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_monthdeprrate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_usemonth">
            <label class="weui-form-preview__label">{{customLabel.fa_usemonth || "使用月份"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_usemonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_useyears">
            <label class="weui-form-preview__label">{{customLabel.fa_useyears || "使用年限"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_useyears
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_cumulativedepr">
            <label class="weui-form-preview__label">{{customLabel.fa_cumulativedepr || "累计折旧"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_cumulativedepr
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_networth">
            <label class="weui-form-preview__label">{{customLabel.fa_networth || "净值"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_networth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_provisionmonth">
            <label class="weui-form-preview__label">{{customLabel.fa_provisionmonth || "已计提月份"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_provisionmonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_monthdepramount">
            <label class="weui-form-preview__label">{{customLabel.fa_monthdepramount || "月折旧额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.fa_monthdepramount
            }}</span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <file-list v-model="form.main.fa_picture" />
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.createTime
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/oa/fixedassets",
      codeField: "fa_code",
      statusField: "fa_statuscode",
      caller: "FixedAssets",
      xtype: "oa-fixedassets-formpanel",
    };
  },
};
</script>